import apiClient from './client'

export const tarifService = {
  getTarifs: () => apiClient.get('/tarifs'),

  createTarif: (data) => apiClient.post('/tarifs', data),

  getTarifById: (id) => apiClient.get(`/tarifs/${id}`),

  updateTarif: (id, data) => apiClient.put(`/tarifs/${id}`, data),

  deleteTarif: (id) => apiClient.delete(`/tarifs/${id}`),
}

export const pricingPlanService = {
  getPricingPlans: () => apiClient.get('/pricing-plans'),

  createPricingPlan: (data) => apiClient.post('/pricing-plans', data),

  getPricingPlanById: (id) => apiClient.get(`/pricing-plans/${id}`),

  updatePricingPlan: (id, data) => apiClient.put(`/pricing-plans/${id}`, data),

  deletePricingPlan: (id) => apiClient.delete(`/pricing-plans/${id}`),

  togglePricingPlan: (id) => apiClient.put(`/pricing-plans/${id}/toggle`),
}

export default tarifService
